<div class="tw-flex tw-flex-col tw-h-[90vh] tw-overflow-hidden">

  <!-- Items Section - 60% height -->
  <div class="tw-h-[60%] tw-overflow-auto tw-bg-white tw-rounded-lg ">
    <div class="tw-divide-y tw-divide-gray-200">
      @for (item of cart.items; track $index) {
        @if (item.is_void) {
          <div class="tw-flex tw-flex-col tw-justify-center tw-px-4">
            <p class="tw-text-lg tw-font-semibold tw-line-through tw-text-red-500">{{ item.item_name }}</p>
            <ng-container *ngIf="item.first_variant_name">
              <p class="tw-text-md tw-text-red-600">{{ item.first_variant_name }}</p>
            </ng-container>
            <ng-container *ngIf="item.second_variant_name">
              <p class="tw-text-md tw-text-red-600">{{ item.second_variant_name }}</p>
            </ng-container>
            @for (option of item.children; track $index) {
              <p class="tw-text-md tw-text-red-600">{{ option.item_name }}</p>
            }
          </div>
        } @else {
          <div class="tw-overflow-hidden tw-bg-gray-100 tw-rounded-lg tw-shadow-md tw-p-4 tw-mb-4">
            <div class="tw-flex tw-justify-between tw-items-center">
              <div class="tw-flex tw-flex-col">
                <p class="tw-text-lg tw-font-semibold tw-text-red-900">{{ item.item_name }}</p>
                <ng-container *ngIf="item.first_variant_name">
                  <p class="tw-text-md tw-text-gray-700">{{ item.first_variant_name }}</p>
                </ng-container>
                <ng-container *ngIf="item.second_variant_name">
                  <p class="tw-text-md tw-text-gray-700">{{ item.second_variant_name }}</p>
                </ng-container>
                @for (option of item.children; track $index) {
                  <p class="tw-text-md tw-text-gray-700">{{ option.item_name }}</p>
                }
              </div>
              <div class="tw-text-2xl tw-font-semibold tw-text-red-900">x{{ item.item_quantity }}</div>
            </div>
          </div>
        }
      }
    </div>
  </div>

  <!-- Order Details Section - 40% height -->
  <div class="tw-h-[40%] tw-overflow-hidden tw-flex tw-flex-col tw-justify-between tw-bg-white tw-rounded-lg tw-mt-4">
    <div class="tw-border-b tw-pb-4">
      <div class="tw-flex tw-justify-between tw-text-xl tw-font-semibold tw-text-gray-900">
        <p>Subtotal</p>
        <p>{{ cart.sub_total }}</p>
      </div>
      <div class="tw-flex tw-justify-between tw-text-lg tw-text-gray-700">
        <p>Discount</p>
        <p>{{ cart.total_discount }}</p>
      </div>
      <div class="tw-flex tw-justify-between tw-text-lg tw-text-gray-700">
        <p>Taxes</p>
        <p>{{ cart.total_tax }}</p>
      </div>
      <div class="tw-flex tw-justify-between tw-text-lg tw-text-gray-700">
        <p>Delivery Charge</p>
        <p>{{ cart.delivery_charge_amount || 0 }}</p>
      </div>
      <div class="tw-flex tw-justify-between tw-text-lg tw-text-gray-700">
        <p>Service Charge</p>
        <p>{{ cart.service_charge_amount || 0 }}</p>
      </div>
      <div class="tw-flex tw-justify-between tw-text-lg tw-text-gray-700">
        <p>Packaging Charge</p>
        <p>{{ cart.packaging_charge_amount || 0 }}</p>
      </div>
      <div class="tw-flex tw-justify-between tw-text-2xl tw-font-bold tw-text-red-900">
        <p>Total</p>
        <p>{{ cart.total }}</p>
      </div>
    </div>
  </div>
</div>
